var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcEdit = function SvgIcEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_edit_svg__clip0_27984_14802)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.06.612a1.225 1.225 0 0 0-1.672.449l-.98 1.697 3.677 2.122.98-1.697a1.225 1.225 0 0 0-.449-1.673L11.061.612Zm.495 5.187L7.88 3.676l-5.001 8.662a1.225 1.225 0 0 0-.066 1.094l.802 1.877 2.027-.245c.382-.046.72-.27.914-.603l5-8.662Z"
  }))));
};
export default SvgIcEdit;